module.exports = {
	"description": "CardBlock is used to normalize font sizes for content and to provide consistent margins and padding.",
	"methods": []
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-docgen-loader!./src/Card/CardBlock.js
// module id = 1601
// module chunks = 0